import React, { useState } from "react";
import styles from "./viewTestList.module.css";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../../labels";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import DatePickerModel from "./DatePickerModel/DatePickerModel";
function ViewTestList() {
  let page = R_PER_PAGE;
  const [activeTab, setActiveTab] = useState(1);
  const [activeTabName, setActiveTabName] = useState("TNPSC");
  const [sortOrder, setSortOrder] = useState("");
  const [isOpen, setIsOpen] = useState({});
  const [assignStatus, assignSetStatus] = useState([]);
  const [status, setStatus] = useState([]);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  const [evaluateStatus, evaluateSetStatus] = useState([]);
  const [numOfAnsSheet, numOfAnsSheetSetStatus] = useState([]);
  const [dueDate, dueDateSetStatus] = useState([]);

  const [selectedStudents, setSelectedStudents] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);

  const handleTabClick = (tabIndex, name) => {
    setActiveTab(tabIndex);
    setActiveTabName(name);
  };
  const currentDatas = [
    {
      name: "AAAA",
      mobile_no: 9876765656,
      email: "uuu@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "BBBB",
      mobile_no: 9876765656,
      email: "xxx@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 1,
    },
    {
      name: "CCCC",
      mobile_no: 9876765656,
      email: "ggg@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "DDDD",
      mobile_no: 8876765656,
      email: "kkk@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 1,
    },
    {
      name: "EEEE",
      mobile_no: 8876765656,
      email: "xxx@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "FFFF",
      mobile_no: 7876765656,
      email: "vvv@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "GGGG",
      mobile_no: 6876765656,
      email: "jjjj@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "HHHHH",
      mobile_no: 9876765656,
      email: "ddd@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "IIII",
      mobile_no: 9878765656,
      email: "mmm@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "JJJJ",
      mobile_no: 9876565656,
      email: "nnn@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "KKKK",
      mobile_no: 9876465656,
      email: "eee@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "LLLL",
      mobile_no: 9876765696,
      email: "qqq@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "MMMMM",
      mobile_no: 9876765626,
      email: "aaa@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "OOOO",
      mobile_no: 9864765656,
      email: "xxx@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "PPPP",
      mobile_no: 9888765656,
      email: "nnn@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
    {
      name: "QQQQ",
      mobile_no: 9876985656,
      email: "ooo@yopmail.com",
      admissionId: "xxx",
      exam_center_name: "yyy",
      que_status: 0,
    },
  ];
  const totalPages = Math.ceil(currentDatas?.length / rowsPerPage);

  const [filteredData, setFilteredData] = useState(currentDatas);

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    let sortedList = [...filteredData].sort((a, b) => {
      // Convert both strings to lowercase to ensure case-insensitive comparison
      let aValue = a[sortKey]?.toString().toLowerCase();
      let bValue = b[sortKey]?.toString().toLowerCase();

      if (aValue < bValue) {
        return order === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setFilteredData(sortedList);
  };
  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        status: !prevState.status,
        method_of_test: false,
      }));
    } else if (boxName === "evaluateStatus") {
      setIsOpen((prevState) => ({
        evaluateStatus: !prevState.evaluateStatus,
        method_of_test: false,
        status: false,
      }));
    }
  };
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (name === "NotYetEvaluated" || name === "Evaluated") {
      if (checked) {
        // setStatus([...status, value]);
        assignSetStatus([
          ...assignStatus,
          { id: value, name: name, type: "assignStatus" },
        ]);
      } else {
        evaluateSetStatus(evaluateStatus.filter((item) => item.id !== value));
      }
    }
  };
  function loadChipdata() {
    let tempArr = [];
    // setUpdateChipData(status);
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
  }
  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      const filtered = currentDatas.filter((course) =>
        assignStatus.some((s) => s.id === String(course.que_status))
      );

      // Update the filteredData state
      setFilteredData(filtered);
      setIsOpen({
        ...isOpen,
        status: false,
      });
    }
  };
  function updateStateData() {
    filterStatus = assignStatus;
  }
  let filterStatus = [];
  const handleClear = (name) => {
    if (name === "assignStatus") {
      assignSetStatus([]);
      filterStatus = [];
      setFilteredData(currentDatas);
      setIsOpen({
        ...isOpen,
        assignStatus: false,
      });
    } else if (name === "evaluateStatus") {
      assignSetStatus([]);
      filterStatus = [];
      setFilteredData(currentDatas);
      setIsOpen({
        ...isOpen,
        evaluateStatus: false,
      });
    }
  };
  const handleTableCheckboxChange = (e, studentId) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedStudents((prevState) => [...prevState, studentId]);
    } else {
      setSelectedStudents((prevState) =>
        prevState.filter((id) => id !== studentId)
      );
    }
  };

  //pagination
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  // total table data  with pages
  const handlePrev = (newPage) => {
    if (newPage >= 1) {
      setCurrentPage(newPage);
    }
  };
  const handleNext = (newPage) => {
    if (newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const handleShow = () => setShow(true);
  const handleModelClose = () => setOpen(false);
  return (
    // <div className="container-fluid viewTestListMain BathHeader">
    <div
      className={`${styles.viewTestListMain} global_container container-fluid BathHeader`}
    >
      <fieldset className="mt-3">
        <legend className="w-auto">Student List</legend>
        <div className="row">
          <div className="offset-md-12 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  onClick={handleShow}
                  // to={handleShow}
                  className="primaryButton "
                  variant="primary"
                >
                  Assign to Evaluator
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="course-content-nav mb-3">
          <ul className="nav" id="myTab" role="tablist">
            {["TNPSC2024JUNE", "TNPSC2024AUG"].map((tab, index) => (
              <li className="nav-item" key={index} role={tab.toLowerCase()}>
                <button
                  className={
                    activeTab === index + 1 ? "nav-link active" : "nav-link"
                  }
                  id={`${tab.toLowerCase()}-tab`}
                  data-bs-toggle="tab"
                  data-bs-target="#about-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="about-tab-pane"
                  aria-selected={activeTab === index + 1}
                  onClick={() => handleTabClick(index + 1, tab)}
                >
                  {tab}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="row mx-0">
          <div className="col-md-12 tableFormat table-responsive mt-2 px-0">
            <table
              className={`table ${styles.tableListHeader}`}
              id="tableListHeader"
            >
              <thead>
                <tr className={`${styles.rowHeader}`}>
                  <th id={`${styles.th}`} style={{ width: "5% !important" }}>
                    <span className="text_th"></span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Name</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "name")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Admission ID</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "admissionId")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th "> Email ID</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "email")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Phone Number</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Assign Status</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "que_status ")}
                    >
                      import_export
                    </span>
                    <span
                      class={` ${
                        styles.materialIcons
                      } align-middle material-icons  ${
                        assignStatus.length > 0 ? "active_icons" : ""
                      }`}
                      onClick={(e) => handleFilter(e, "status")}
                    >
                      filter_list
                    </span>
                    {isOpen.status === true && (
                      <div className="filterBoxs_popup">
                        <div className="row mt-4">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="NotYetEvaluated"
                                value="0"
                                id="NotYetEvaluated"
                                checked={assignStatus.some((element) => {
                                  if (element.id === "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "NotYetEvaluated")
                                }
                              />
                              <label
                                class={`${styles.PinkText} form-check-label`}
                                for="NotYetEvaluated"
                              >
                                Not Yet Evaluated
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="Evaluated"
                                value="1"
                                id="Evaluated"
                                checked={assignStatus.some((element) => {
                                  if (element.id === "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "Evaluated")
                                }
                              />
                              <label
                                class={`${styles.GreenTexts} form-check-label`}
                                for="Evaluated"
                              >
                                Evaluated
                              </label>
                            </div>
                          </div>
                        </div>

                        <hr />
                        <div className={`${styles.borderWidth} row`}>
                          <ul class="FilterListButton">
                            <li class="listButton">
                              <Link
                                onClick={() => handleClear("status")}
                                className={`${styles.clearFilter} ms-2 `}
                              >
                                Clear
                              </Link>
                            </li>
                            <li class="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("status")}
                                className="primaryButton "
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>

                  <th id={`${styles.th}`}>
                    <span className="text_th">Assigned To</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Assigned Date</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Evaluation Status</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "que_status ")}
                    >
                      import_export
                    </span>
                    <span
                      class={` align-middle ${
                        styles.materialIcons
                      } material-icons  ${
                        evaluateStatus.length > 0 ? "active_icons" : ""
                      }`}
                      // onClick={(e) => handleFilter(e, "evaluateStatus")}
                    >
                      filter_list
                    </span>
                    {isOpen.status === true && (
                      <div className={`${styles.filterBoxs_testlist} p-1`}>
                        <div className="row mt-4">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="NotYetEvaluated"
                                value="0"
                                id="Not Yet Evaluated"
                                checked={evaluateStatus.some((element) => {
                                  if (element.id === "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "NotYetEvaluated")
                                }
                              />
                              <label
                                class={`${styles.PinkText} form-check-label`}
                                for="defaultCheck1"
                              >
                                Not Yet Evaluated
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="Evaluated"
                                value="1"
                                id="Evaluated"
                                checked={evaluateStatus.some((element) => {
                                  if (element.id === "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "Evaluated")
                                }
                              />
                              <label
                                class={`${styles.GreenTexts} form-check-label`}
                                for="defaultCheck1"
                              >
                                Evaluated
                              </label>
                            </div>
                          </div>
                        </div>

                        <hr />
                        <div className="row ">
                          <ul class="FilterListButton">
                            <li class="listButton">
                              <Link
                                onClick={() => handleClear("status")}
                                className={`${styles.clearFilter} ms-2 `}
                              >
                                Clear
                              </Link>
                            </li>
                            <li class="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("status")}
                                className="primaryButton "
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>

                  <th id={`${styles.th}`}>
                    <span className="text_th">Obtained Marks</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Class Rank</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Overall Marks</span>
                    <span
                      className={` material-icons align-middle`}
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    {" "}
                    {/* <span className="text_th">Action</span> */}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentDatas && currentDatas.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentDatas.map((course, index) => (
                    <tr className={styles.rowHover} key={index}>
                      <td id={`${styles.td}`}>
                        <input
                          type="checkbox"
                          onChange={(e) =>
                            handleTableCheckboxChange(e, course.name)
                          }
                        />
                      </td>
                      <td id={`${styles.td}`}>{course.name}</td>
                      <td id={`${styles.td}`}>{course.admissionId}</td>
                      <td
                        className="ellipsis"
                        title={course.email}
                        id={`${styles.td}`}
                      >
                        {course.email}
                      </td>
                      <td id={`${styles.td}`}>{course.mobile_no}</td>

                      {course.que_status === 0 && (
                        <td id={`${styles.td}`}>
                          <span class={`PinkText form-check-label`}>
                            Not Yet Evaluated
                          </span>
                        </td>
                      )}
                      {course.que_status === 1 && (
                        <td id={`${styles.td}`}>
                          <span className="GreenTexts">Evaluated</span>
                        </td>
                      )}
                      <td id={`${styles.td}`}>{course.mobile_no}</td>
                      {course.que_status === 0 && (
                        <td id={`${styles.td}`}>
                          <span className="PinkText">Not Yet Evaluated</span>
                        </td>
                      )}
                      {course.que_status === 1 && (
                        <td id={`${styles.td}`}>
                          <span className="GreenTexts">Evaluated</span>
                        </td>
                      )}
                      <td id={`${styles.td}`}>{course.mobile_no}</td>
                      <td id={`${styles.td}`}>{course.mobile_no}</td>
                      <td id={`${styles.td}`}>{course.mobile_no}</td>
                      <td id={`${styles.td}`}>{course.mobile_no}</td>

                      <td id={`${styles.td}`}>
                        <button
                          className={`${styles.button}`}
                          // onClick={() =>
                          //   handleReadView(course.event_pk, course.que_status)
                          // }
                        >
                          <span class="material-icons">visibility</span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row mt-2 pb-3">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              filteredData && filteredData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              filteredData && filteredData?.length > 0
                ? filteredData?.length < currentPage * rowsPerPage
                  ? filteredData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              filteredData && filteredData?.length > 0
                ? filteredData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            // prevButton="prev_buttonCentreSup  me-2"
            prevButton={`${styles.prev_buttonViewTestList} ${styles.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages}
          />
        </div>
      </fieldset>

      <fieldset className="mt-3">
        <legend className="w-auto">Evaluators List</legend>
        <div className="row mx-0">
          <div className="col-md-12 tableFormat table-responsive mt-2 px-0">
            <table
              className={`table ${styles.tableListHeader}`}
              id="tableListHeader"
            >
              <thead>
                <tr className={`${styles.rowHeader}`}>
                  <th id={`${styles.th}`} style={{ width: "5% !important" }}>
                    <span className="text_th"></span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Name</span>
                    <span
                      className="material-icons align-middle"
                      onClick={(e) => handleSort(e, "name")}
                    >
                      import_export
                    </span>
                  </th>

                  <th id={`${styles.th}`}>
                    <span className="text_th "> Email ID</span>
                    <span
                      className="material-icons align-middle"
                      onClick={(e) => handleSort(e, "email")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">Phone Number</span>
                    <span
                      className="material-icons align-middle"
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span className="text_th">
                      Number of Answer Sheets Assigned
                    </span>
                    <span
                      className="material-icons align-middle"
                      onClick={(e) => handleSort(e, "que_status ")}
                    >
                      import_export
                    </span>
                    <span
                      class={` align-middle material-icons  ${
                        numOfAnsSheet.length > 0 ? "active_icons" : ""
                      }`}
                      // onClick={(e) => handleFilter(e, "status")}
                    >
                      filter_list
                    </span>
                  </th>
                  {isOpen.status === true && (
                    <div className={`${styles.filterBoxs_testlist} p-1`}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="NotYetEvaluated"
                              value="0"
                              id="Not Yet Evaluated"
                              checked={numOfAnsSheet.some((element) => {
                                if (element.id === "0") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "NotYetEvaluated")
                              }
                            />
                            <label
                              class={`${styles.PinkText} form-check-label`}
                              for="defaultCheck1"
                            >
                              Not Yet Evaluated
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Evaluated"
                              value="1"
                              id="Evaluated"
                              checked={numOfAnsSheet.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Evaluated")
                              }
                            />
                            <label
                              class={`${styles.GreenTexts} form-check-label`}
                              for="defaultCheck1"
                            >
                              Evaluated
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row ">
                        <ul class="FilterListButton">
                          <li class="listButton">
                            <Link
                              onClick={() => handleClear("status")}
                              className={`${styles.clearFilter} ms-2 `}
                            >
                              Clear
                            </Link>
                          </li>
                          <li class="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("status")}
                              className="primaryButton "
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}

                  <th id={`${styles.th}`}>
                    <span className="text_th">Due Date</span>
                    <span
                      className="material-icons align-middle"
                      onClick={(e) => handleSort(e, "que_status ")}
                    >
                      import_export
                    </span>
                    <span
                      class={` align-middle material-icons  ${
                        dueDate.length > 0 ? "active_icons" : ""
                      }`}
                    >
                      filter_list
                    </span>
                  </th>
                  {isOpen.dueDate === true && (
                    <div className={`${styles.filterBoxs_testlist} p-1`}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="NotYetEvaluated"
                              value="0"
                              id="Not Yet Evaluated"
                              checked={dueDate.some((element) => {
                                if (element.id === "0") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "NotYetEvaluated")
                              }
                            />
                            <label
                              class={`${styles.PinkText} form-check-label`}
                              for="defaultCheck1"
                            >
                              Not Yet Evaluated
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Evaluated"
                              value="1"
                              id="Evaluated"
                              checked={dueDate.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Evaluated")
                              }
                            />
                            <label
                              class={`${styles.GreenTexts} form-check-label`}
                              for="defaultCheck1"
                            >
                              Evaluated
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row ">
                        <ul class="FilterListButton">
                          <li class="listButton">
                            <Link
                              onClick={() => handleClear("status")}
                              className={`${styles.clearFilter} ms-2 `}
                            >
                              Clear
                            </Link>
                          </li>
                          <li class="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("status")}
                              className="primaryButton "
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}

                  <th id={`${styles.th}`}>
                    <span className="text_th">Status</span>
                    <span
                      className="material-icons align-middle"
                      onClick={(e) => handleSort(e, "que_status ")}
                    >
                      import_export
                    </span>
                  </th>
                  {isOpen.status === true && (
                    <div className={`${styles.filterBoxs_testlist} p-1`}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="NotYetEvaluated"
                              value="0"
                              id="Not Yet Evaluated"
                              checked={status.some((element) => {
                                if (element.id === "0") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "NotYetEvaluated")
                              }
                            />
                            <label
                              class={`${styles.PinkText} form-check-label`}
                              for="defaultCheck1"
                            >
                              Not Yet Evaluated
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Evaluated"
                              value="1"
                              id="Evaluated"
                              checked={status.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Evaluated")
                              }
                            />
                            <label
                              class={`${styles.GreenTexts} form-check-label`}
                              for="defaultCheck1"
                            >
                              Evaluated
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row ">
                        <ul class="FilterListButton">
                          <li class="listButton">
                            <Link
                              onClick={() => handleClear("status")}
                              className={`${styles.clearFilter} ms-2 `}
                            >
                              Clear
                            </Link>
                          </li>
                          <li class="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("status")}
                              className="primaryButton "
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}

                  <th id={`${styles.th}`}>
                    {" "}
                    <span className="text_th"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentDatas && currentDatas.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentDatas.map((course, index) => (
                    <tr className={styles.rowHover} key={index}>
                      <td id={`${styles.td}`}>
                        <input
                          type="checkbox"
                          onChange={(e) =>
                            handleTableCheckboxChange(e, course.name)
                          }
                        />
                      </td>
                      <td id={`${styles.td}`}>{course.name}</td>
                      <td id={`${styles.td}`}>{course.admissionId}</td>
                      <td
                        className="ellipsis"
                        title={course.email}
                        id={`${styles.td}`}
                      >
                        {course.email}
                      </td>

                      {course.que_status === 0 && (
                        <td id={`${styles.td}`}>
                          <span className="PinkText">Not Yet Evaluated</span>
                        </td>
                      )}
                      {course.que_status === 1 && (
                        <td id={`${styles.td}`}>
                          <span className="GreenTexts">Evaluated</span>
                        </td>
                      )}
                      <td id={`${styles.td}`}>{course.mobile_no}</td>
                      {course.que_status === 0 && (
                        <td id={`${styles.td}`}>
                          <span className={`"PinkText"`}>
                            Not Yet Evaluated
                          </span>
                        </td>
                      )}
                      {course.que_status === 1 && (
                        <td id={`${styles.td}`}>
                          <span className="GreenTexts">Evaluated</span>
                        </td>
                      )}

                      <td id={`${styles.td}`}>
                        <button
                          className={`${styles.button}`}
                          // onClick={() =>
                          //   handleReadView(course.event_pk, course.que_status)
                          // }
                        >
                          <span class="material-icons">visibility</span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row mt-2 pb-3">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              filteredData && filteredData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              filteredData && filteredData?.length > 0
                ? filteredData?.length < currentPage * rowsPerPage
                  ? filteredData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              filteredData && filteredData?.length > 0
                ? filteredData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            // prevButton="prev_buttonCentreSup  me-2"
            prevButton={`${styles.prev_buttonViewTestList} ${styles.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages}
          />
        </div>
      </fieldset>
      <Modal show={open} onHide={handleModelClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className={`${styles.view_title} mb-0`} id="exampleModalLabel">
              Assign to Evaluators
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row global_container">
            <div className="col-12">
              <form className="row g-3">
                {/* ---select 1 */}
                <div className="col-md-6">
                  <label
                    htmlFor="chooseTest"
                    className="form-label confirm_value"
                  >
                    Evaluator Name 1
                  </label>
                  <Select
                    className="shadow-none input-font-size"
                    placeholder="Select Evaluator Name 1"
                    isClearable
                    // value={selectedTest}
                    // onChange={handleSelectTestChange}
                  />
                </div>
                {/* ---text--- */}
                <div className="mt-3 col-md-6">
                  <div className="d-flex flex-column mt-2">
                    <p className="confirm_label mb-1 p-0">
                      Number of Answer Sheets Assigned Already
                    </p>
                    <p className="confirm_value m-0 p-0">100</p>
                  </div>
                </div>
                {/* ---select 2 -- */}
                <div className="col-md-6">
                  <label
                    htmlFor="chooseTest"
                    className="form-label confirm_value"
                  >
                    Evaluator Name 2
                  </label>
                  <Select
                    className="shadow-none input-font-size"
                    placeholder="Select Evaluator Name 2"
                    isClearable
                  />
                </div>
                {/* ---text 2--- */}
                <div className="mt-3 col-md-6">
                  <div className="d-flex flex-column mt-2">
                    <p className="confirm_label mb-1 p-0">
                      Number of Answer Sheets Assigned Already
                    </p>
                    <p className="confirm_value m-0 p-0">100</p>
                  </div>
                </div>
                {/* DATE */}
                <div className="col-md-6">
                  <div className="forms ">
                    <label htmlFor="startDate" class="form-label confirm_value">
                      Due Date
                    </label>
                    <DatePickerModel placeholder="Select Due Date" />

                    <small className="error"></small>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Link
            className={styles.cancel_button}
            onClick={handleModelClose}
            to={handleModelClose}
          >
            Back to View Test
          </Link>

          <Button
            className={styles.DashboardButton}
            variant="primary"
            onClick={handleModelClose}
          >
            Assign Now
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ViewTestList;
